export const ActionState = Object.freeze({
  OK: 'OK',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  LOADING: 'LOADING',
  UNAVAILABLE: 'UNAVAILABLE'
});

/** Action represents a single action that can be performed
 * on a contract. */

class BaseAction {
  isValid() {
    return this.state === ActionState.OK;
  }

  /** @note invalid actions are disabled and show a validation message in the tooltip */
  isInvalid() {
    return this.state === ActionState.VALIDATION_ERROR;
  }

  /** @note loading actions are disabled and show a generic loading message in the tooltip */
  isLoading() {
    return this.state === ActionState.LOADING;
  }
  isAvailable() {
    return this.state !== ActionState.UNAVAILABLE;
  }

  /** @note unavailable actions are not displayed in the UI */
  isUnavailable() {
    return this.state === ActionState.UNAVAILABLE;
  }
}
class OkAction extends BaseAction {
  constructor(action) {
    super();
    this.state = ActionState.OK;
    this.messageKey = action.messageKey;
    this.onClick = action.onClick;
  }
}
class InvalidAction extends BaseAction {
  constructor(action) {
    super();
    this.state = ActionState.VALIDATION_ERROR;
    this.messageKey = action.messageKey;
    this.onClick = action.onClick;
    this.validationMessageKey = action.validationMessageKey;
  }
}
class LoadingAction extends BaseAction {
  constructor(action) {
    super();
    this.state = ActionState.LOADING;
    this.messageKey = action.messageKey;
    this.onClick = action.onClick;
    this.loadingMessageKey = action.loadingMessageKey;
  }
}
class UnavailableAction extends BaseAction {
  constructor(...args) {
    super(...args);
    this.state = ActionState.UNAVAILABLE;
  }
}
export class ContractAction {
  static ok(action) {
    return new OkAction(action);
  }
  static invalid(action) {
    return new InvalidAction(action);
  }
  static loading(action) {
    return new LoadingAction(action);
  }
  static unavailable() {
    return new UnavailableAction();
  }
}
export const ContractActions = Object.freeze({
  VIEW_CHANGE_QUOTE: 'VIEW_CHANGE_QUOTE',
  CREATE_CHANGE_QUOTE: 'CREATE_CHANGE_QUOTE',
  CANCEL_CHANGE_QUOTE: 'CANCEL_CHANGE_QUOTE',
  VIEW_RENEWAL_QUOTE: 'VIEW_RENEWAL_QUOTE',
  CREATE_RENEWAL_QUOTE: 'CREATE_RENEWAL_QUOTE',
  CANCEL_RENEWAL_QUOTE: 'CANCEL_RENEWAL_QUOTE',
  RESCHEDULE_TERMINATION: 'RESCHEDULE_TERMINATION',
  CANCEL_TERMINATION: 'CANCEL_TERMINATION',
  TERMINATE: 'TERMINATE',
  UPDATE_PAYMENT_METHOD: 'UPDATE_PAYMENT_METHOD',
  DELETE_CONTRACT: 'DELETE_CONTRACT'
});